import React from 'react'

import CoverListItem from '../../components/quotation/coverListItem/CoverListItem'
import CoverListOption from '../../components/quotation/coverListOption/CoverListOption'
import { useQuotation } from '../context'
import CoverListItemString from '../../components/quotation/coverListItemString/CoverListItemString'

type Props = React.PropsWithChildren & {
  displayOnlyCover?: boolean
}

export const PricingMREAcheelCoversOptions = ({ displayOnlyCover }: Props) => {
  const { quotation } = useQuotation()

  const covers = quotation.covers?.mreAcheel
  const details = quotation.details.mreAcheel
  const premium = quotation.premium?.mreAcheel

  return (
    <div className="space-y-3">
      <CoverListItemString label="Limite contractuelle d'indemnité" data={covers?.Lci} />
      <CoverListItemString label="Vol" data={covers?.theftProperty} />
      <CoverListItemString label="Vandalisme" data={covers?.vandalismExcludingBuildings} />
      <CoverListItemString label="Incendie" data={covers?.fire} />
      <CoverListItemString label="Catastrophes naturelles" data={covers?.naturalDisasters} />
      <CoverListItemString label="Bris de glaces" data={covers?.glassBreakage} />
      <CoverListItemString label="Bris de machine" data={covers?.machineryBreakdown} />
      <CoverListItemString label="Dégâts des eaux" data={covers?.waterDamage} />
      <CoverListItemString label="Rc Exploitation" data={covers?.rcAvLivraison} />
      <CoverListItemString
        label="Rc après Livraison et / ou professionnelle"
        data={covers?.rcApLivraison}
      />

      <CoverListOption label="Bien en chambre froide" option={covers?.chambreFroide != null} />
      <CoverListItemString label="Marchandises" data={covers?.marchandises} />
      <CoverListItemString label="Tous risques informatiques" data={covers?.allComputerRisks} />

      {covers?.chocVehiculesTer === true && (
        <CoverListOption
          label="Choc de véhicules terrestres identifiés"
          option={covers?.chocVehiculesTer != null}
        />
      )}

      <CoverListItemString
        label="Frais supplémentaires d'exploitation - Pertes d’exploitation - Pertes de recettes"
        data={covers?.fraisExploitation}
      />

      {/* Checking if the user selected the option as well as if the option is available, to avoid confusing the user */}
      {/*{(!displayOnlyCover ||*/}
      {/*  (details?.operatingLiabilityOption === true &&*/}
      {/*    premium?.operatingLiabilityOption != null)) && (*/}
      {/*  <CoverListOption*/}
      {/*    label="Responsabilité civile d'exploitation"*/}
      {/*    option={*/}
      {/*      details?.operatingLiabilityOption === true && premium?.operatingLiabilityOption != null*/}
      {/*    }*/}
      {/*  />*/}
      {/*)}*/}

      {/*{(!displayOnlyCover ||*/}
      {/*  (details?.legalProtectionOption === true && premium?.legalProtectionOption != null)) && (*/}
      {/*  <CoverListOption*/}
      {/*    label="Protection juridique"*/}
      {/*    option={details?.legalProtectionOption === true && premium?.legalProtectionOption != null}*/}
      {/*  />*/}
      {/*)}*/}

      {/*{(!displayOnlyCover ||*/}
      {/*  (details?.assistanceOption === true && premium?.assistanceOption != null)) && (*/}
      {/*  <CoverListOption*/}
      {/*    label="Assistance"*/}
      {/*    option={details?.assistanceOption === true && premium?.assistanceOption != null}*/}
      {/*  />*/}
      {/*)}*/}

      {/*{(!displayOnlyCover ||*/}
      {/*  (details?.financialLossStandardOption === true &&*/}
      {/*    premium?.financialLossStandardOption != null) ||*/}
      {/*  (details?.financialLossAdvantageOption === true &&*/}
      {/*    premium?.financialLossAdvantageOption != null)) && (*/}
      {/*  <CoverListOption*/}
      {/*    label="Pertes financières"*/}
      {/*    option={*/}
      {/*      (details?.financialLossStandardOption === true &&*/}
      {/*        premium?.financialLossStandardOption != null) ||*/}
      {/*      (details?.financialLossAdvantageOption === true &&*/}
      {/*        premium?.financialLossAdvantageOption != null)*/}
      {/*    }*/}
      {/*  />*/}
      {/*)}*/}
    </div>
  )
}
